import {createActionObject} from '../../redux/utils'
import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as api from './apiCalls'
import {loadPurchaseData, setPeriod, setUnlimitedAction, setUsersCountAction} from './components/chooser/actions'
import {licensesType, MONTH_LICENSES_DURATION, PricingModelType, UNLIMITED_USERS_COUNT, USERS_LIMITED_PACKAGES, YEAR_LICENSES_DURATION} from './constants'

export const loadedDataSet = createAction(ActionTypes.LOADED_DATA_SET)

export const getLicensesInitialData = (successCallback = () => {}) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.LOAD_DATA))
    api.getLicensesPageInitialData()
       .then(data => {
           successCallback()
           dispatch(loadedDataSet(data))
           dispatch(predefinePurchaseParameters(data))
           dispatch(createActionObject(ActionTypes.LOAD_DATA_SUCCESS))
       })
       .catch((error) => {
           dispatch(createActionObject(ActionTypes.LOAD_DATA_FAILURE))
       })
}

const predefinePurchaseParameters = (loadedData) => (dispatch) => {
    const lastLicense = loadedData.licenses[loadedData.licenses.length - 1]
    let usersCount = 1
    if (lastLicense.type === licensesType.TRIAL) {
        usersCount = loadedData.currentUsedUserCount
    } else if (lastLicense.usersCount !== UNLIMITED_USERS_COUNT) {
        usersCount = lastLicense.usersCount
    }
    usersCount = usersCount < loadedData.usersLowerLimit ? loadedData.usersLowerLimit : usersCount
    if (loadedData.pricingModelType === PricingModelType.PACKAGE) {
        usersCount = USERS_LIMITED_PACKAGES.find(p => p >= usersCount) || USERS_LIMITED_PACKAGES[USERS_LIMITED_PACKAGES.length - 1]
    }

    dispatch(setUsersCountAction(usersCount))
    dispatch(setUnlimitedAction(
        lastLicense.type !== licensesType.TRIAL &&
        (lastLicense.usersCount === UNLIMITED_USERS_COUNT || lastLicense.usersCount > loadedData.unlimitedFrom)
    ))

    if (lastLicense.type === licensesType.COMMERCIAL && lastLicense.durationInMonths <= MONTH_LICENSES_DURATION) {
        dispatch(setPeriod(MONTH_LICENSES_DURATION))
    } else {
        dispatch(setPeriod(YEAR_LICENSES_DURATION))
    }
    dispatch(loadPurchaseData())
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/actions.js